import { Injectable } from '@angular/core';

import { AprimaAnalyticsService } from './AprimaAnalyticsService';
import { BridgeService } from './BridgeService';
import { TransitionManagerService } from './navigation/TransitionManagerService';
import { WebCommonStorageRepository } from './WebCommonStorageRepository';

@Injectable({
  providedIn: 'root',
})
export class LogOffService {
  static readonly ajsFactoryName = 'LogOffServiceTs';

  constructor(
    private aprimaAnalyticsService: AprimaAnalyticsService,
    private bridge: BridgeService,
    private transitionManagerService: TransitionManagerService,
    private webCommonStorageRepository: WebCommonStorageRepository,
  ) {
  }

  logoff(): Promise<void> {
    this.webCommonStorageRepository.removeJsonWebToken();
    this.webCommonStorageRepository.removeUserId();
    this.aprimaAnalyticsService.sendEvent('user', 'click', 'logoff', '0');

    this.bridge.fireEvent('logoff', {
      message: 'logoff',
    });

    return Promise.resolve();
  }

  logoffFromUnauthorizedResponse(): void {
    const deviceId = this.webCommonStorageRepository.getDeviceId();
    const jwt = this.webCommonStorageRepository.getJsonWebToken();
    const jwtDesc = typeof jwt === 'undefined' ? 'undefined' : jwt ? jwt.length : '"falsy token"';
    const msg = 'User logged out by 401. Redirected to login. DeviceId=' + deviceId + ' JWT:' + jwtDesc;

    // eslint-disable-next-line no-console
    console.info(msg);
    this.aprimaAnalyticsService.sendException(msg);

    this.transitionManagerService.transitionToLogin();
  }
}
